module.exports = __webpack_public_path__ + "static/media/a-6.60502291.jpg";